import { Call, Close, Email, MoreVert, RemoveRedEye, Search } from "@mui/icons-material";
import { Autocomplete, Avatar, Backdrop, Box, Button, Card, CardContent, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Drawer, FormControl, FormControlLabel, Grid, IconButton, InputLabel, Menu, MenuItem, Pagination, Rating, Select, Step, StepButton, Stepper, Switch, Table, TableBody, TableCell, TableRow, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import MDTypography from "components/MDTypography";
import { ClearIcon } from "@mui/x-date-pickers";
import colors from "assets/theme/base/colors";

export const EmailDialog = ({ openEmail, handleCloseEmail, selectedCandidateEmail }) => {
    return (
        <>
            <Dialog open={openEmail} onClose={handleCloseEmail} PaperProps={{
                sx: { width: "50%" }
            }}>
                <DialogTitle>Send Email to Candidate</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {selectedCandidateEmail && (
                            <>
                                <Typography sx={{ fontSize: "16px" }}>Name: {selectedCandidateEmail?.full_name}</Typography>
                                <Typography sx={{ fontSize: "16px" }}>Email: {selectedCandidateEmail?.email}</Typography>

                                <DialogContent>
                                    <TextField
                                        id="filled-multiline-flexible"
                                        label="Message"
                                        variant="filled"
                                        sx={{ width: '-webkit-fill-available' }}
                                    />
                                </DialogContent>
                                <Button>Send Email</Button>
                            </>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEmail}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export const ScheduleInterviewDialog = ({ openScheduleDialog, handleCloseScheduleDialog, employeesList, interviewTimeError, interviewTime, interviewDateError, interviewDate, description, finalInterview, selectedCandidate, interviewerNameError, setScheduleInterviewRecord, setInterviewerNameError, setInterviewTime, setInterviewTimeError, setInterviewDate, setInterviewDateError, setDescription, setFinalInterview, gmeetAuthenticated, handleScheduleInterview, scheduleInterviewRecord, meetingModeError, setMeetingModeError }) => {
    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        backgroundColor: "white",
                        borderRadius: "22px",
                        width: "620px",
                        maxWidth: "92vw",
                    },
                }}
                open={openScheduleDialog}
                onClose={handleCloseScheduleDialog}
            >
                {/* {showAlert && (
                  <MDAlert
                    color="primary"
                    dismissible
                    onClick={() => {
                      setShowAlert(null);
                    }}
                  >
                    {alertContent(showAlert)}
                  </MDAlert>
                )} */}
                <DialogTitle
                    style={{
                        borderBottom: "50px solid",
                        background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.primary.main} 100%)`,
                        color: "white",
                    }}
                >
                    <Typography variant="h5" style={{ color: "white" }}>
                        Schedule Interview
                    </Typography>
                    <Typography variant="body2" style={{ color: "rgba(255,255,255,0.86)" }}>
                        Capture the schedule details once so invites and stage tracking stay aligned.
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {selectedCandidate?.candidate ? (
                        <Box
                            sx={{
                                mt: 2,
                                mb: 1,
                                p: 1.5,
                                borderRadius: "16px",
                                backgroundColor: colors.background.accent,
                                border: `1px solid ${colors.info.main}20`,
                            }}
                        >
                            <Typography fontWeight={700}>
                                {selectedCandidate.candidate.full_name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {selectedCandidate.candidate.email} | {selectedCandidate.candidate.mobile}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {selectedCandidate?.current_flow?.name || "Flow"} / {selectedCandidate?.current_stage?.name || "Stage"}
                            </Typography>
                        </Box>
                    ) : null}
                    <Grid item xs={22} sm={12}>
                        <Autocomplete
                            id="interviewerName"
                            multiple
                            options={employeesList || []}
                            getOptionLabel={(option) =>
                                option.user.firstname + " " + option.user.lastname
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    name="interviewerName"
                                    label="Interviewer Name"
                                    required
                                    error={!!interviewerNameError}
                                    helperText={interviewerNameError}
                                    sx={{
                                        backgroundColor: '#fff',
                                        '& .MuiInputBase-root': {
                                            backgroundColor: '#fff',
                                        },
                                        '& .MuiAutocomplete-tag': {
                                            backgroundColor: '#F9F9F9',
                                            color: 'inherit',
                                        },
                                        '& .MuiAutocomplete-clearIndicator': {
                                            backgroundColor: '#fff',
                                        },
                                        '& .MuiAutocomplete-tag .MuiSvgIcon-root': {
                                            color: "#000000",
                                            '&:hover': {
                                                color: "#000000", // Keeps the color black on hover
                                            },
                                        },
                                    }}
                                />
                            )}
                            onChange={(event, newValue) => {
                                if (newValue) {

                                    setScheduleInterviewRecord((state) => ({
                                        ...state,
                                        interviewer: newValue
                                    }));
                                }
                                setInterviewerNameError("");
                            }}
                        />
                    </Grid>
                    <Grid
                        container
                        spacing={4}
                        sx={{ marginTop: -3 }}
                        alignItems={"center"}
                    >
                        <Grid item xs={12}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                id="interviewDatetime"
                                label="Interview Date & Time"
                                type="datetime-local"
                                fullWidth
                                variant="outlined"
                                name="interviewDatetime"
                                required
                                error={!!interviewDateError || !!interviewTimeError}
                                helperText={interviewDateError || interviewTimeError}
                                value={scheduleInterviewRecord?.datetime || ""}
                                onChange={(event) => {
                                    setScheduleInterviewRecord((state) => ({
                                        ...state,
                                        datetime: event.target.value,
                                    }));
                                    setInterviewDate(event.target.value);
                                    setInterviewTime(event.target.value);
                                    setInterviewDateError("");
                                    setInterviewTimeError("");
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth margin="dense">
                                <InputLabel id="meeting-mode-label">Interview Mode</InputLabel>
                                <Select
                                    labelId="meeting-mode-label"
                                    value={scheduleInterviewRecord?.mode || "online"}
                                    label="Interview Mode"
                                    onChange={(event) => {
                                        setScheduleInterviewRecord((state) => ({
                                            ...state,
                                            mode: event.target.value,
                                        }));
                                        setMeetingModeError("");
                                    }}
                                >
                                    <MenuItem value="online">Online</MenuItem>
                                    <MenuItem value="offline">Offline</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="Timezone"
                                fullWidth
                                variant="outlined"
                                value={scheduleInterviewRecord?.timezone || "Asia/Kolkata"}
                                onChange={(event) => {
                                    setScheduleInterviewRecord((state) => ({
                                        ...state,
                                        timezone: event.target.value,
                                    }));
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                id="date"
                                label="Description"
                                placeholder="Description"
                                fullWidth
                                variant="outlined"
                                name="interviewDate"
                                required
                                value={description}
                                onChange={(event) => setDescription(event.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="h8">Final Interview</MDTypography>
                            <Switch
                                checked={finalInterview}
                                onChange={() => {
                                    setFinalInterview(!finalInterview);
                                }}
                            />
                        </Grid>
                        {scheduleInterviewRecord?.mode === "online" ? (
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    margin="dense"
                                    label="Meeting Link"
                                    fullWidth
                                    variant="outlined"
                                    value={scheduleInterviewRecord?.meeting_link || ""}
                                    error={Boolean(meetingModeError)}
                                    helperText={meetingModeError}
                                    onChange={(event) => {
                                        setScheduleInterviewRecord((state) => ({
                                            ...state,
                                            meeting_link: event.target.value,
                                        }));
                                        setMeetingModeError("");
                                    }}
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    margin="dense"
                                    label="Location"
                                    fullWidth
                                    variant="outlined"
                                    value={scheduleInterviewRecord?.address || ""}
                                    error={Boolean(meetingModeError)}
                                    helperText={meetingModeError}
                                    onChange={(event) => {
                                        setScheduleInterviewRecord((state) => ({
                                            ...state,
                                            address: event.target.value,
                                        }));
                                        setMeetingModeError("");
                                    }}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: "14px",
                                    backgroundColor: "#F9F9F9",
                                }}
                            >
                                <Typography fontWeight={600} fontSize="14px">
                                    Required fields
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Interviewer, date-time, mode, timezone, and the correct location detail are required before scheduling.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: "space-between", padding: "16px 24px 20px" }}>
                    <Typography variant="body2" color="text.secondary">
                        Required: interviewer, date-time, mode, and location details.
                    </Typography>
                    <Box display="flex" gap={1}>
                    <Button onClick={handleCloseScheduleDialog}>Cancel</Button>
                    <Button variant="contained" onClick={() => {
                        if (gmeetAuthenticated) {
                            handleScheduleInterview();
                        } else {
                            alert("You are not authenticated with Google Meet & Calendar Events. Please enable it from recruitment settings")
                        }

                    }}>Schedule</Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}

export const AddCandidateDialog = ({ recordsOpen, handleRecordsClose, activeStep, isSmallScreen, steps, completed, handleStep, allStepsCompleted, showAlert, newRecord, handleInputChange, fullNameError, numberError, emailError, experienceError, candidateOptionValues, convertSource, employeesList, editedData, editableRowIndex, convertStatus, cvError, handleFileSelect, totalSteps, handleBack, handleAddRecord, sourceError, statusError, setNewRecord, setSourceError, setStatusError, advertisementss, handleJobOpenings, jdError, advertisement, isSmallScreenJOBOpenings, isMediumScreen }) => {
    return (
        <>
            <Dialog
                PaperProps={{
                    sx: {
                        backgroundColor: "white",
                        boxShadow: "0 24px 64px rgba(15, 23, 42, 0.18)",
                        width: "min(1120px, 96vw)",
                        maxWidth: "none",
                        borderRadius: "28px",
                        paddingBottom: "20px",
                        overflow: "hidden",
                    },
                }}
                open={recordsOpen}
                onClose={handleRecordsClose}
            >
                <Box>
                    <Box
                        sx={{
                            px: { xs: 2, md: 3 },
                            py: 2.5,
                            background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                            color: "white",
                            position: "relative",
                        }}
                    >
                        <Typography variant="h4" fontWeight={700} color="white">
                            Add Candidate
                        </Typography>
                        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.86)", maxWidth: 640, mt: 0.5 }}>
                            Create a candidate profile first, then confirm the job opening so the recruitment flow starts in the right place.
                        </Typography>
                    </Box>
                    <Stepper nonLinear activeStep={activeStep} orientation={isSmallScreen ? 'vertical' : 'horizontal'} sx={{
                        background: "none",
                        px: isSmallScreen ? "24px" : "80px",
                        pt: 3,
                        "& .MuiStepIcon-root.Mui-active": {
                            background: "#66AEF2 !important",
                            fill: " #66AEF2 !important",
                            stroke: "none !important",
                        },
                        "& .MuiStepIcon-root": {
                            background: " #9FC9FF !important",
                            fill: "#9FC9FF !important",
                            stroke: "none !important",
                            fontSize: "50px !important",
                            width: "1.8125rem !important",
                            height: "1.8125rem !important",
                        },
                        "& .MuiStepConnector-line": {
                            color: "#9FC9FF",
                            display: "flex",
                            justifyContent: "center",
                        },
                        "& .MuiStepLabel-label": {
                            marginBottom: "0.5rem",
                        },
                        "& .MuiStepButton-root": {
                            padding: "9px 16px !important",
                        },
                    }}>
                        {steps.map((label, index) => (
                            <Step key={label} completed={completed[index]}>
                                <StepButton color="inherit" onClick={handleStep(index)}>
                                    <span style={{ color: "#000" }}>{label}</span>
                                </StepButton>
                            </Step>
                        ))}
                        <IconButton sx={{ position: 'absolute', right: 15, top: 18 }}
                            onClick={() => {
                                // setJobAdvertisementPayload({});
                                handleRecordsClose(false);
                                // clearValidation();
                            }}
                        >
                            <ClearIcon />
                        </IconButton>
                    </Stepper>
                    <div>
                        {allStepsCompleted() ? (
                            <React.Fragment>
                                <Typography sx={{ mt: 2, mb: 1 }}>
                                    All steps completed - you&apos;re finished
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    <Button onClick={handleReset}>Reset</Button>
                                </Box>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Box>
                                    {/* Render content based on activeStep */}
                                    {activeStep === 0 && (
                                        <>

                                            {showAlert && (
                                                <MDAlert
                                                    color="primary"
                                                    dismissible
                                                    onClick={() => {
                                                        setShowAlert(null);
                                                    }}
                                                >
                                                    {alertContent(showAlert)}
                                                </MDAlert>
                                            )}

                                            <DialogContent style={{ maxHeight: "70vh", padding: "0px 32px 8px" }}>
                                                <Box
                                                    sx={{
                                                        p: 2,
                                                        mb: 2,
                                                        borderRadius: "18px",
                                                        backgroundColor: colors.background.accent,
                                                        border: `1px solid ${colors.info.main}20`,
                                                    }}
                                                >
                                                    <Typography fontWeight={700}>
                                                        Candidate information
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Add the core details here. Each required field helps us move the candidate cleanly into the recruitment pipeline.
                                                    </Typography>
                                                </Box>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            margin="dense"
                                                            id="name"
                                                            label="Name"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            name="full_name"
                                                            value={newRecord.full_name}
                                                            onChange={handleInputChange}
                                                            required
                                                            error={!!fullNameError}
                                                            helperText={fullNameError}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            margin="dense"
                                                            id="number"
                                                            label="Number"
                                                            type="number"
                                                            fullWidth
                                                            variant="outlined"
                                                            name="mobile"
                                                            value={newRecord.mobile}
                                                            onChange={handleInputChange}
                                                            required
                                                            error={!!numberError}
                                                            helperText={numberError}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            margin="dense"
                                                            id="email"
                                                            label="Email"
                                                            type="email"
                                                            fullWidth
                                                            variant="outlined"
                                                            name="email"
                                                            value={newRecord.email}
                                                            onChange={handleInputChange}
                                                            required
                                                            error={!!emailError}
                                                            helperText={emailError}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            margin="dense"
                                                            id="experience"
                                                            label="Experience"
                                                            type="number"
                                                            fullWidth
                                                            variant="outlined"
                                                            name="experience"
                                                            value={newRecord.experience}
                                                            onChange={handleInputChange}
                                                            required
                                                            error={!!experienceError}
                                                            helperText={experienceError}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Autocomplete
                                                            options={
                                                                candidateOptionValues?.source
                                                                    ? Object.entries(candidateOptionValues?.source).map(
                                                                        ([key, value]) => ({ value: key, label: value })
                                                                    )
                                                                    : []
                                                            }
                                                            value={convertSource(newRecord.source)}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    setNewRecord((state) => ({
                                                                        ...state,
                                                                        source: newValue?.value,
                                                                    }));
                                                                }
                                                                setSourceError("");
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Source"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    error={!!sourceError}
                                                                    helperText={sourceError}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Autocomplete
                                                            id="recruiter"
                                                            options={employeesList}
                                                            value={editedData[editableRowIndex]?.recruiter}
                                                            getOptionLabel={(option) =>
                                                                Array.isArray(option)
                                                                    ? option.map(
                                                                        (item) => item.user.firstname + " " + item.user.lastname
                                                                    )
                                                                    : option.user.firstname + " " + option.user.lastname
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    fullWidth
                                                                    name="recruiter"
                                                                    label="Recruiter"
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    const selectedValues = Array.isArray(newValue)
                                                                        ? newValue.map((v) => v.id)
                                                                        : [newValue.id];
                                                                    setNewRecord((state) => ({
                                                                        ...state,
                                                                        recruiter: selectedValues,
                                                                    }));
                                                                }
                                                            }}
                                                        />
                                                    </Grid>


                                                    <Grid item xs={6}>
                                                        <Autocomplete
                                                            options={
                                                                candidateOptionValues?.status
                                                                    ? Object.entries(candidateOptionValues?.status).map(
                                                                        ([key, value]) => ({ value: key, label: value })
                                                                    )
                                                                    : []
                                                            }
                                                            value={convertStatus(newRecord.status)}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    setNewRecord((state) => ({
                                                                        ...state,
                                                                        status: newValue?.value,
                                                                    }));
                                                                }
                                                                setStatusError("");
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Status"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    error={!!statusError}
                                                                    helperText={statusError}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            InputLabelProps={{ shrink: true }}
                                                            error={!!cvError}
                                                            helperText={cvError}
                                                            label="Resume"
                                                            variant="outlined"
                                                            fullWidth
                                                            type="file"
                                                            onChange={handleFileSelect}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </DialogContent>
                                        </>

                                    )}
                                    {activeStep === 1 && (
                                        <>
                                            <Grid container spacing={2} marginTop={2} alignItems="center" sx={{ padding: "0 20px" }}>
                                                <Grid item xs={12}>
                                                    <Box
                                                        sx={{
                                                            p: 2,
                                                            borderRadius: "18px",
                                                            backgroundColor: colors.background.accent,
                                                            border: `1px solid ${colors.info.main}20`,
                                                        }}
                                                    >
                                                        <MDTypography sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                                            Select Job Opening
                                                        </MDTypography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Attach the candidate to the correct opening so they appear in the expected recruitment flow and stage.
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12} md={8} lg={6}>
                                                    <Autocomplete
                                                        name="jd"
                                                        multiple
                                                        options={advertisementss}
                                                        getOptionLabel={(option) => option?.position}
                                                        value={newRecord.jd?.length > 0 ? newRecord?.jd : advertisementss.filter((item) => item?.position === advertisement?.position)}
                                                        onChange={(event, value) => {
                                                            if (value && value.length > 0) {
                                                                setNewRecord((state) => ({
                                                                    ...state,
                                                                    jd: value,
                                                                }));
                                                            }
                                                            setStatusError("");
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                required
                                                                id="autocomplete"
                                                                label="Job Openings"
                                                                variant="outlined"
                                                                error={!!jdError}
                                                                helperText={jdError}
                                                                //sx={{
                                                                //    backgroundColor: '#fff',
                                                                //    '& .MuiInputBase-root': {
                                                                //        backgroundColor: '#fff',
                                                                //    },
                                                                //    '& .MuiAutocomplete-tag': {
                                                                //        backgroundColor: '#F9F9F9',
                                                                //        color: 'inherit',
                                                                //    },
                                                                //    '& .MuiAutocomplete-clearIndicator': {
                                                                //        backgroundColor: '#fff',
                                                                //    },
                                                                //    '& .MuiAutocomplete-tag .MuiSvgIcon-root': {
                                                                //        color: "#000000",
                                                                //    },
                                                                //}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Box sx={{ display: "flex", flexDirection: isSmallScreenJOBOpenings ? "column" : "row", flexWrap: "wrap", gap: "20px", mt: 2, justifyContent: "center" }}>
                                                {newRecord?.jd?.length === undefined || newRecord?.jd?.length === 0 ? (
                                                    <Card sx={{ padding: "20px", width: isSmallScreenJOBOpenings ? "100%" : isMediumScreen ? "45%" : "30%", flex: "1 1 calc(30% - 20px)" }}>
                                                        <Box sx={{ display: "flex", gap: "20px" }}>
                                                            <Box>
                                                                <Avatar alt="Profile Picture" sx={{ width: 50, height: 50 }} />
                                                            </Box>
                                                            <Box>
                                                                <Typography mt={1} sx={{ fontWeight: "500", fontSize: "19px" }}>
                                                                    {advertisement.position}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ borderBottom: "1px solid gray", margin: "10px 0", width: "100%" }} />
                                                        <Box>
                                                            <Typography sx={{ fontSize: "13px" }}>
                                                                <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                                                    Education :
                                                                </Typography>
                                                                {advertisement.education}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: "13px" }}>
                                                                <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                                                    Experience :
                                                                </Typography>
                                                                {advertisement.experience}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: "13px" }}>
                                                                <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                                                    Vacancy :
                                                                </Typography>
                                                                {advertisement.vacancy}
                                                            </Typography>
                                                        </Box>
                                                    </Card>
                                                ) : (
                                                    Array.isArray(newRecord.jd) && newRecord.jd.map((item, index) => (
                                                        <Card sx={{ padding: "20px", width: isSmallScreenJOBOpenings ? "100%" : isMediumScreen ? "45%" : "30%", flex: "1 1 calc(30% - 20px)" }} key={index}>
                                                            <Box sx={{ display: "flex", gap: "20px" }}>
                                                                <Box>
                                                                    <Avatar alt="Profile Picture" sx={{ width: 50, height: 50 }} />
                                                                </Box>
                                                                <Box>
                                                                    <Typography mt={1} sx={{ fontWeight: "500", fontSize: "19px" }}>
                                                                        {item.position}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box sx={{ borderBottom: "1px solid gray", margin: "10px 0", width: "100%" }} />
                                                            <Box>
                                                                <Typography sx={{ fontSize: "13px" }}>
                                                                    <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                                                        Education :
                                                                    </Typography>
                                                                    {item.education}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: "13px" }}>
                                                                    <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                                                        Experience :
                                                                    </Typography>
                                                                    {item.experience}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: "13px" }}>
                                                                    <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                                                        Vacancy :
                                                                    </Typography>
                                                                    {item.vacancy}
                                                                </Typography>
                                                            </Box>
                                                        </Card>
                                                    ))
                                                )}
                                            </Box>

                                            {/* <Box sx={{ display: "flex", justifyContent: "right", m: 2 }}>
                                                    <MDButton variant="gradient" color="dark" onClick={handleJobOpenings}>Submit</MDButton>
                                                </Box> */}
                                        </>
                                    )}
                                </Box>
                                <DialogActions
                                    sx={{
                                        display: "flex",
                                        flexDirection: isSmallScreen ? "column" : "row",
                                        alignItems: isSmallScreen ? "center" : "flex-start",
                                        justifyContent: "space-between",
                                        padding: isSmallScreen ? "0px 20px" : "0px 60px",
                                        gap: isSmallScreen ? 2 : 0,
                                    }}
                                >
                                    <Box>
                                        {activeStep !== totalSteps() - 1 && (
                                            <Box sx={{
                                                display: "flex",
                                                // justifyContent: "space-between",
                                                justifyContent: isSmallScreen ? "center" : "space-between",
                                                width: "100%",
                                                padding: "0px 15px",
                                                marginTop: isSmallScreen ? "90px" : "15px",
                                            }}>
                                                <MDButton
                                                    variant="gradient"
                                                    color="dark"
                                                    onClick={() => {
                                                        // setJobAdvertisementPayload({});
                                                        handleRecordsClose(false);
                                                        // clearValidation();
                                                    }}
                                                >
                                                    Cancel
                                                </MDButton>
                                            </Box>
                                        )}
                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: isSmallScreen ? "column" : "row",
                                        pt: 2,
                                    }}>
                                        <MDButton
                                            variant="gradient"
                                            color="dark"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                        >
                                            Back
                                        </MDButton>
                                        <Box sx={{ flex: '1 1 auto' }} />



                                        {activeStep === totalSteps() - 1 ? (
                                            <>
                                                <MDButton variant="gradient" color="dark" onClick={handleJobOpenings}>Submit</MDButton>
                                            </>
                                        ) : (
                                            <>
                                                <MDButton
                                                    variant="gradient"
                                                    color="dark"
                                                    disabled={activeStep === totalSteps() - 1}
                                                    onClick={handleAddRecord}
                                                    // onClick={handleNext}
                                                    sx={{
                                                        mr: 1, marginTop: isSmallScreen ? "20px" : "0px",
                                                    }}
                                                >
                                                    Continue
                                                </MDButton>
                                            </>
                                        )}

                                        {/* {activeStep !== steps.length &&
                                                      (completed[activeStep] ? (
                                                        <Typography variant="caption" sx={{ display: 'inline-block' }}>
                                                          Step {activeStep + 1} already completed
                                                        </Typography>
                                                      ) : (
                                                        <Button onClick={handleComplete}>
                                                          {completedSteps() === totalSteps() - 1
                                                            ? 'Finish'
                                                            : 'Complete Step'}
                                                        </Button>
                                                      ))} */}
                                    </Box>
                                </DialogActions>
                            </React.Fragment>
                        )}
                    </div>
                </Box>
            </Dialog>
        </>
    )
}

export const CandidateInformationDialog = ({ candidateNameDialog, editedData, editableRowIndex, candidateOptionValues, convertStatus, convertSource, employeeOptions, advertisements, handleFileSelect, detail, permissions, modulePermissions, jdError, handleFieldChange, setJDError, handleCancelClick, setCandidateNameDialog, handleSaveClick }) => {
    const candidateRecord = editedData?.[editableRowIndex] || {};
    return (
        <>
            <Dialog
                PaperProps={{
                    sx: {
                        backgroundColor: "white",
                        width: "min(860px, 96vw)",
                        maxWidth: "none",
                        borderRadius: "28px",
                        overflow: "hidden",
                        boxShadow: "0 28px 72px rgba(15, 23, 42, 0.22)",
                    },
                }}
                open={candidateNameDialog}
                onClose={() => {
                    setCandidateNameDialog(false);
                }}
            >
                <DialogTitle
                    sx={{
                        px: 3,
                        py: 2.5,
                        background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                        color: "white",
                    }}
                >
                    <Typography variant="h5" fontWeight={700} color="white">
                        Candidate Details
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.86)", mt: 0.5 }}>
                        Review and update the candidate profile, recruiter mapping, and linked job opening from one place.
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ px: 3, py: 3 }}>
                    <Box
                        sx={{
                            p: 2,
                            mb: 2.5,
                            borderRadius: "18px",
                            backgroundColor: colors.background.accent,
                            border: `1px solid ${colors.info.main}20`,
                        }}
                    >
                        <Typography fontWeight={700}>
                            {candidateRecord?.full_name || "Candidate"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {candidateRecord?.email || "No email"} {candidateRecord?.mobile ? `| ${candidateRecord.mobile}` : ""}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Experience: {candidateRecord?.experience || 0} years
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                id="name"
                                label="Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="full_name"
                                value={candidateRecord?.full_name || ""}
                                onChange={(event) => handleFieldChange(event, "full_name")}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id="mobile"
                                label="Mobile"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="mobile"
                                value={candidateRecord?.mobile || ""}
                                onChange={(event) => handleFieldChange(event, "mobile")}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id="experience"
                                label="Experience"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="experience"
                                value={candidateRecord?.experience || ""}
                                onChange={(event) => handleFieldChange(event, "experience")}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id="email"
                                label="Email"
                                type="text"
                                fullWidth
                                variant="outlined"
                                name="email"
                                value={candidateRecord?.email || ""}
                                onChange={(event) => handleFieldChange(event, "email")}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                options={
                                    candidateOptionValues?.status
                                        ? Object.entries(candidateOptionValues?.status).map(
                                            ([key, value]) => ({ value: key, label: value })
                                        )
                                        : []
                                }
                                value={convertStatus(candidateRecord?.status)}
                                onChange={(event, newValue) => {
                                    handleFieldChange(
                                        { target: { value: newValue?.value } },
                                        "status"
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                options={
                                    candidateOptionValues?.status
                                        ? Object.entries(candidateOptionValues?.source)?.map(
                                            ([key, value]) => ({
                                                value: key,
                                                label: value,
                                            })
                                        )
                                        : []
                                }
                                value={convertSource(candidateRecord?.source)}
                                onChange={(event, newValue) => {
                                    handleFieldChange(
                                        { target: { value: newValue?.value } },
                                        "source"
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Source"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6} alignSelf={"end"}>
                            <Autocomplete
                                id="recruiter"
                                options={employeeOptions}
                                getOptionLabel={(option) => option.label}
                                value={
                                    candidateRecord?.recruiter
                                        ? employeeOptions.find(
                                            (option) =>
                                                option.value ==
                                                candidateRecord?.recruiter
                                        )
                                        : null
                                }
                                fullWidth

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        name="recruiter"
                                        label="Recruiter"
                                        variant="outlined"

                                    />
                                )}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        const selectedValues = Array.isArray(newValue)
                                            ? newValue.map((v) => v.value)
                                            : newValue.value;
                                        handleFieldChange(
                                            { target: { value: selectedValues } },
                                            "recruiter"
                                        );
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: "18px",
                                    backgroundColor: colors.background.accent,
                                    border: `1px solid ${colors.info.main}20`,
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Box>
                                    <MDTypography variant="h6">
                                        Job Mapping
                                    </MDTypography>
                                    <Typography variant="body2" color="text.secondary">
                                        Keep the candidate linked to the correct opening so stage movement stays accurate.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                name="jd"
                                options={advertisements}
                                getOptionLabel={(e) => e?.position}
                                value={
                                    candidateRecord?.job_ad
                                        ? advertisements.find(
                                            (option) =>
                                                option.id ==
                                                candidateRecord?.job_ad
                                        )
                                        : null
                                }
                                onChange={(event, value) => {
                                    handleFieldChange(
                                        { target: { value: value?.id ?? null } },
                                        "job_ad"
                                    );

                                    setJDError("");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        id="autocomplete"
                                        label="Job Openings"
                                        type="text"
                                        variant="outlined"
                                        error={!!jdError}
                                        helperText={jdError}
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item xs={6} alignSelf="end">
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                label="Resume"
                                variant="outlined"
                                fullWidth
                                type="file"
                                onChange={handleFileSelect}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: "18px",
                                    backgroundColor: colors.background.accent,
                                    border: `1px solid ${colors.info.main}20`,
                                }}
                            >
                                <MDTypography variant="h6" mb={1}>
                                    Risk Flags
                                </MDTypography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <Typography fontWeight={600} fontSize="14px">Blacklisted</Typography>
                                        <Box display="flex" gap={1}>
                                            <FormControlLabel
                                                control={<Checkbox checked={detail.blacklisted} disabled color="primary" inputProps={{ "aria-label": "blacklist-yes-checkbox" }} />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={!detail.blacklisted} disabled color="primary" inputProps={{ "aria-label": "blacklist-no-checkbox" }} />}
                                                label="No"
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography fontWeight={600} fontSize="14px">Suspicious</Typography>
                                        <Box display="flex" gap={1}>
                                            <FormControlLabel
                                                control={<Checkbox checked={detail.suspicious} disabled color="primary" inputProps={{ "aria-label": "suspicious-yes-checkbox" }} />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={!detail.suspicious} disabled color="primary" inputProps={{ "aria-label": "suspicious-no-checkbox" }} />}
                                                label="No"
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography fontWeight={600} fontSize="14px">Blocked by NASSCOM</Typography>
                                        <Box display="flex" gap={1}>
                                            <FormControlLabel
                                                control={<Checkbox checked={detail.blocked} disabled color="primary" inputProps={{ "aria-label": "blocked-yes-checkbox" }} />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={!detail.blocked} disabled color="primary" inputProps={{ "aria-label": "blocked-no-checkbox" }} />}
                                                label="No"
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3, justifyContent: "space-between" }}>
                    <Typography variant="body2" color="text.secondary">
                        Update the profile here only when the candidate data really changed.
                    </Typography>
                    <Box display="flex" gap={1}>
                    <MDButton
                        variant="outlined"
                        color="dark"
                        onClick={() => {
                            handleCancelClick();
                            setCandidateNameDialog(false);
                        }}
                    >
                        Cancel
                    </MDButton>
                    {permissions?.includes(modulePermissions?.update_permission) && (
                        <MDButton
                            variant="contained"
                            color="info"
                            onClick={async () => {
                                await handleSaveClick();
                            }}
                        >
                            Update
                        </MDButton>
                    )}
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}
